<template>
    <v-toolbar class="controls map" color="transparent" elevation="0">
        <v-btn v-if="geoLocationIsEnabled" color="primary" fab fas @click="$emit('pan-to-current-location')">
          <v-icon>fal fa-search-location</v-icon>
        </v-btn>

        <v-btn @click="showTripWaypoints = !showTripWaypoints" color="primary lighten-1" disabled fab fas>
            <v-icon>fal fa-code-branch</v-icon>
        </v-btn>

        <v-btn @click="toggleHeatmap" color="primary" disabled fab fas>
            <v-icon>fal fa-fire</v-icon>
        </v-btn>

        <v-tooltip top transition="scroll-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn @click="$emit('show-fleet')" color="secondary" fab fas v-on="on">
                    <v-icon>fal fa-arrows</v-icon>
                </v-btn>
            </template>
            <span>{{ t({s: 'showFleet', component: 'Map.tools'}) }}</span>
        </v-tooltip>

        <v-tooltip top transition="scroll-y-transition" v-if="user.role === 'Super Admin'">
          <template v-slot:activator="{ on }">
            <v-btn @click="toggleDebugging" color="primary lighten-1" fab fas v-on="on" :disabled="selectedEntity === null && !active" >
              <v-icon v-if="!active">fal fa-plug</v-icon>
              <v-icon v-if="active">fas fa-plug</v-icon>
            </v-btn>
          </template>
          <span>
            <span v-if="active">Disconnect</span>
            <span v-if="!active">Connect</span> live debugger</span>
        </v-tooltip>
    </v-toolbar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'BottomControls',
  computed: {
    ...mapState('Controls', [
      'realtime',
      'heatmap',
      'fleet'
    ]),
    ...mapState(['user']),
    ...mapState('Debug', ['active']),
    selectedEntity () {
      return this.$route.params.imei ? parseInt(this.$route.params.imei.toString()) : null
    },
    geoLocationIsEnabled () {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

      return isSafari
        ? location.protocol === 'https:' && navigator.geolocation
        : navigator.geolocation
    }
  },
  methods: {
    ...mapMutations('Controls', [
      'toggleHeatmap'
    ]),
    toggleDebugging () {
      if (!this.active) {
        this.$store.commit('Debug/track', { devices: [this.selectedEntity] })
      } else {
        this.$store.commit('Debug/stop')
      }
    }
  }
}
</script>

<style>
.controls {
  position: absolute;
  right: 4em;
  z-index: 5;
}

.controls.map {
  padding: 0;
  bottom: 1.65em;
}

.controls.map .v-toolbar__content {
  height: auto !important;
}

.controls.map button {
  margin-right: 0.75em;
}

.controls.map button:last-of-type {
  margin-right: 0;
}
</style>
